import { createContext, useContext, useEffect, useState } from 'react'
import { RequestService } from '../services/RequestService'
import { useSnackbar } from '../hooks'

const ImportActionsModalContext = createContext()

export const ImportActionsModalProvider = ({ children }) => {
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const { successSnackbar, errorSnackbar } = useSnackbar()
  const [selectedFile, setSelectedFile] = useState(null)

  const handleResetFile = () => {
    setSelectedFile(null)
  }

  const openModal = () => {
    setOpen(true)
  }

  const closeModal = () => {
    setOpen(false)
  }

  const handleDownloadTemplate = type => {
    const link = document.createElement('a')
    link.fileName = `${type}_import.csv`
    link.href = `/csv-templates/${link.fileName}`
    link.download = link.fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const handleFileChange = event => {
    const file = event.target.files[0]
    setSelectedFile(file)
  }

  const handleUpload = async type => {
    if (!selectedFile) return

    setLoading(true)
    const formData = new FormData()
    formData.append('file', selectedFile)

    const file = formData.get('file')
    try {
      const response = await RequestService.postImports({
        type,
        data: file,
      })

      if (response.status == 'success') {
        successSnackbar({ text: 'Arquivo Importado!' })
        handleResetFile()
        closeModal()
      } else {
        errorSnackbar({ text: 'Importação com erro!' })
      }
    } catch (error) {
      console.error('Error uploading file:', error)
      errorSnackbar({ text: 'Importação com erro!' })
    } finally {
      setLoading(false)
    }
  }

  return (
    <ImportActionsModalContext.Provider
      value={{
        open,
        openModal,
        closeModal,
        loading,
        handleDownloadTemplate,
        handleUpload,
        handleFileChange,
        selectedFile,
        handleResetFile,
      }}
    >
      {children}
    </ImportActionsModalContext.Provider>
  )
}

export const useImportActionsModal = () => {
  return useContext(ImportActionsModalContext)
}
